import React, { useState } from 'react';
import Dialog from '../../../components/Dialog';
import { IconPencil } from '../../../components/dialogIcons';

/*
  Editing one line: its number, its description and its vendor.

  Built to Group E's approved drawing on 5 September 2026,
  `docs/design/group-e/dialog-edit-line-*.png`.

  **It was rendered on the screen and could never open.** `setEditModal` appeared
  twice in `CountEntry.jsx` and both of them set it to `null`, so nothing could
  ever put a line in it: the dialog existed, was maintained, was drawn in Group E
  as dialog 7 of eighteen, and was unreachable from any of the three layouts. The
  row menu carries "Edit this line" now, at all three sizes.

  **What it is for.** A line's number or description can be wrong on the sheet
  itself, most often on a line somebody added by hand that is not in the catalog,
  and the alternative was removing the line and adding it again, which loses the
  count on it.
*/
export default function EditItemModal({ item, onSave, onClose }) {
  const [itemNum, setItemNum] = useState(item.item_number_raw || '');
  const [desc, setDesc]       = useState(item.description_raw || '');
  const [vendor, setVendor]   = useState(item.vendor_raw || '');
  const ready = itemNum.trim().length > 0;

  return (
    <Dialog
      kind="info" icon={<IconPencil />}
      title="Edit this line"
      record={[item.item_number_raw, item.description_raw].filter(Boolean).join(' - ')}
      says="The item number is required. The other two may be left blank."
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-quiet" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" disabled={!ready}
            onClick={() => onSave(item.id, { itemNum: itemNum.trim(), desc, vendor })}>
            Save changes
          </button>
        </>
      }
    >
      <div className="form-lbl" style={{ marginTop: 0 }}>Item number</div>
      <input className="form-inp" value={itemNum} onChange={e => setItemNum(e.target.value)} autoFocus />
      <div className="form-lbl">Description</div>
      <input className="form-inp" value={desc} onChange={e => setDesc(e.target.value)} />
      <div className="form-lbl">Vendor</div>
      <input className="form-inp" value={vendor} onChange={e => setVendor(e.target.value)} />
    </Dialog>
  );
}
